/**
 * CONTINAS CONTANTS URL currencies
 */

const currencies = [
    {'currency_id': 'AED', 'name': 'UAE Dirham'},
    {'currency_id': 'AFN', 'name': 'Afghanis'},
    {'currency_id': 'ALL', 'name': 'Leke'},
    {'currency_id': 'AMD', 'name': 'Armenian Dram'},
    {'currency_id': 'ANG', 'name': 'Guilders'},
    {'currency_id': 'AOA', 'name': 'Kwanza'},
    {'currency_id': 'ARS', 'name': 'Pesos'},
    {'currency_id': 'AUD', 'name': 'Dollars'},
    {'currency_id': 'AWG', 'name': 'Guilders'},
    {'currency_id': 'AZN', 'name': 'New Manats'},
    {'currency_id': 'BAM', 'name': 'Convertible Marka'},
    {'currency_id': 'BBD', 'name': 'Dollars'},
    {'currency_id': 'BDT', 'name': 'Taka'},
    {'currency_id': 'BGN', 'name': 'Leva'},
    {'currency_id': 'BHD', 'name': 'Bahraini Dinar'},
    {'currency_id': 'BIF', 'name': 'Burundi Franc'},
    {'currency_id': 'BMD', 'name': 'Dollars'},
    {'currency_id': 'BND', 'name': 'Dollars'},
    {'currency_id': 'BOB', 'name': 'Bolivianos'},
    {'currency_id': 'BRL', 'name': 'Reais'},
    {'currency_id': 'BSD', 'name': 'Dollars'},
    {'currency_id': 'BTN', 'name': 'Ngultrum'},
    {'currency_id': 'BWP', 'name': 'Pula'},
    {'currency_id': 'BYN', 'name': 'Belarusian Ruble'},
    {'currency_id': 'BYR', 'name': 'Rubles'},
    {'currency_id': 'BZD', 'name': 'Dollars'},
    {'currency_id': 'CAD', 'name': 'Dollars'},
    {'currency_id': 'CDF', 'name': 'Congolese Franc'},
    {'currency_id': 'CHF', 'name': 'Switzerland Francs'},
    {'currency_id': 'CLP', 'name': 'Pesos'},
    {'currency_id': 'CNY', 'name': 'Yuan Renminbi'},
    {'currency_id': 'COP', 'name': 'Pesos'},
    {'currency_id': 'CRC', 'name': 'Colón'},
    {'currency_id': 'CUP', 'name': 'Pesos'},
    {'currency_id': 'CVE', 'name': 'Cape Verde Escudo'},
    {'currency_id': 'CZK', 'name': 'Koruny'},
    {'currency_id': 'DJF', 'name': 'Djibouti Franc'},
    {'currency_id': 'DKK', 'name': 'Kroner'},
    {'currency_id': 'DOP', 'name': 'Pesos'},
    {'currency_id': 'DZD', 'name': 'Algerian Dinar'},
    {'currency_id': 'EGP', 'name': 'Pounds'},
    {'currency_id': 'ERN', 'name': 'Nakfa'},
    {'currency_id': 'ETB', 'name': 'Ethiopian Birr'},
    {'currency_id': 'EUR', 'name': 'Euro'},
    {'currency_id': 'FJD', 'name': 'Dollars'},
    {'currency_id': 'FKP', 'name': 'Pounds'},
    {'currency_id': 'GBP', 'name': 'Pounds'},
    {'currency_id': 'GEL', 'name': 'Lari'},
    {'currency_id': 'GGP', 'name': 'Pounds'},
    {'currency_id': 'GHC', 'name': 'Cedis'},
    {'currency_id': 'GHS', 'name': 'Cedi'},
    {'currency_id': 'GIP', 'name': 'Pounds'},
    {'currency_id': 'GMD', 'name': 'Dalasi'},
    {'currency_id': 'GNF', 'name': 'Guinea Franc'},
    {'currency_id': 'GTQ', 'name': 'Quetzales'},
    {'currency_id': 'GYD', 'name': 'Dollars'},
    {'currency_id': 'HKD', 'name': 'Dollars'},
    {'currency_id': 'HNL', 'name': 'Lempiras'},
    {'currency_id': 'HRK', 'name': 'Kuna'},
    {'currency_id': 'HTG', 'name': 'Gourde'},
    {'currency_id': 'HUF', 'name': 'Forint'},
    {'currency_id': 'IDR', 'name': 'Rupiahs'},
    {'currency_id': 'ILS', 'name': 'New Shekels'},
    {'currency_id': 'IMP', 'name': 'Pounds'},
    {'currency_id': 'INR', 'name': 'Rupees'},
    {'currency_id': 'IQD', 'name': 'Iraqi Dinar'},
    {'currency_id': 'IRR', 'name': 'Rials'},
    {'currency_id': 'ISK', 'name': 'Kronur'},
    {'currency_id': 'JEP', 'name': 'Pounds'},
    {'currency_id': 'JMD', 'name': 'Dollars'},
    {'currency_id': 'JOD', 'name': 'Jordanian Dinar'},
    {'currency_id': 'JPY', 'name': 'Yen'},
    {'currency_id': 'KES', 'name': 'Kenyan Shilling'},
    {'currency_id': 'KGS', 'name': 'Soms'},
    {'currency_id': 'KHR', 'name': 'Riels'},
    {'currency_id': 'KMF', 'name': 'Comorian franc'},
    {'currency_id': 'KPW', 'name': 'Won'},
    {'currency_id': 'KRW', 'name': 'Won'},
    {'currency_id': 'KWD', 'name': 'Kuwaiti Dinar'},
    {'currency_id': 'KYD', 'name': 'Dollars'},
    {'currency_id': 'KZT', 'name': 'Tenge'},
    {'currency_id': 'LAK', 'name': 'Kips'},
    {'currency_id': 'LBP', 'name': 'Pounds'},
    {'currency_id': 'LKR', 'name': 'Rupees'},
    {'currency_id': 'LRD', 'name': 'Dollars'},
    {'currency_id': 'LSL', 'name': 'Loti'},
    {'currency_id': 'LTL', 'name': 'Litai'},
    {'currency_id': 'LVL', 'name': 'Lati'},
    {'currency_id': 'LYD', 'name': 'Libyan Dinar'},
    {'currency_id': 'MAD', 'name': 'Moroccan Dirham'},
    {'currency_id': 'MDL', 'name': 'Moldovan Leu'},
    {'currency_id': 'MGA', 'name': 'Malagasy Ariary'},
    {'currency_id': 'MKD', 'name': 'Denars'},
    {'currency_id': 'MMK', 'name': 'Kyat'},
    {'currency_id': 'MNT', 'name': 'Tugriks'},
    {'currency_id': 'MOP', 'name': 'Pataca'},
    {'currency_id': 'MRU', 'name': 'Ouguiya'},
    {'currency_id': 'MUR', 'name': 'Rupees'},
    {'currency_id': 'MVR', 'name': 'Rufiyaa'},
    {'currency_id': 'MWK', 'name': 'Kwacha'},
    {'currency_id': 'MXN', 'name': 'Pesos'},
    {'currency_id': 'MYR', 'name': 'Ringgits'},
    {'currency_id': 'MZN', 'name': 'Meticais'},
    {'currency_id': 'NAD', 'name': 'Dollars'},
    {'currency_id': 'NGN', 'name': 'Nairas'},
    {'currency_id': 'NIO', 'name': 'Cordobas'},
    {'currency_id': 'NOK', 'name': 'Krone'},
    {'currency_id': 'NPR', 'name': 'Rupees'},
    {'currency_id': 'NZD', 'name': 'Dollars'},
    {'currency_id': 'OMR', 'name': 'Rials'},
    {'currency_id': 'PAB', 'name': 'Balboa'},
    {'currency_id': 'PEN', 'name': 'Nuevos Soles'},
    {'currency_id': 'PGK', 'name': 'Kina'},
    {'currency_id': 'PHP', 'name': 'Pesos'},
    {'currency_id': 'PKR', 'name': 'Rupees'},
    {'currency_id': 'PLN', 'name': 'Zlotych'},
    {'currency_id': 'PYG', 'name': 'Guarani'},
    {'currency_id': 'QAR', 'name': 'Rials'},
    {'currency_id': 'RON', 'name': 'New Lei'},
    {'currency_id': 'RSD', 'name': 'Dinars'},
    {'currency_id': 'RUB', 'name': 'Rubles'},
    {'currency_id': 'RWF', 'name': 'Rwanda Franc'},
    {'currency_id': 'SAR', 'name': 'Riyals'},
    {'currency_id': 'SBD', 'name': 'Dollars'},
    {'currency_id': 'SCR', 'name': 'Rupees'},
    {'currency_id': 'SDG', 'name': 'Sudanese Pound'},
    {'currency_id': 'SEK', 'name': 'Kronor'},
    {'currency_id': 'SGD', 'name': 'Dollars'},
    {'currency_id': 'SHP', 'name': 'Pounds'},
    {'currency_id': 'SLL', 'name': 'Leone'},
    {'currency_id': 'SOS', 'name': 'Shillings'},
    {'currency_id': 'SRD', 'name': 'Dollars'},
    {'currency_id': 'SSP', 'name': 'South Sudanese pound'},
    {'currency_id': 'STN', 'name': 'Dobra'},
    {'currency_id': 'SVC', 'name': 'Colones'},
    {'currency_id': 'SYP', 'name': 'Pounds'},
    {'currency_id': 'SZL', 'name': 'Lilangeni'},
    {'currency_id': 'THB', 'name': 'Baht'},
    {'currency_id': 'TJS', 'name': 'Somoni'},
    {'currency_id': 'TMT', 'name': 'Manat'},
    {'currency_id': 'TND', 'name': 'Tunisian Dinar'},
    {'currency_id': 'TOP', 'name': 'Pa’anga'},
    {'currency_id': 'TRL', 'name': 'Liras'},
    {'currency_id': 'TRY', 'name': 'Lira'},
    {'currency_id': 'TTD', 'name': 'Dollars'},
    {'currency_id': 'TVD', 'name': 'Dollars'},
    {'currency_id': 'TWD', 'name': 'New Dollars'},
    {'currency_id': 'TZS', 'name': 'Tanzanian Shilling'},
    {'currency_id': 'UAH', 'name': 'Hryvnia'},
    {'currency_id': 'UGX', 'name': 'Uganda Shilling'},
    {'currency_id': 'USD', 'name': 'Dollars'},
    {'currency_id': 'UYU', 'name': 'Pesos'},
    {'currency_id': 'UZS', 'name': 'Sums'},
    {'currency_id': 'VEF', 'name': 'Bolivares Fuertes'},
    {'currency_id': 'VES', 'name': 'Venezuelan bolívar'},
    {'currency_id': 'VND', 'name': 'Dong'},
    {'currency_id': 'VUV', 'name': 'Vatu'},
    {'currency_id': 'WST', 'name': 'Tala'},
    {'currency_id': 'XAF', 'name': 'CFA Franc BCEAO'},
    {'currency_id': 'XCD', 'name': 'Dollars'},
    {'currency_id': 'XDR', 'name': 'Special Drawing Rights'},
    {'currency_id': 'XOF', 'name': 'West African CFA franc'},
    {'currency_id': 'XPF', 'name': 'CFP Franc'},
    {'currency_id': 'YER', 'name': 'Rials'},
    {'currency_id': 'ZAR', 'name': 'Rand'},
    {'currency_id': 'ZMW', 'name': 'Zambian Kwacha'},
    {'currency_id': 'ZWD', 'name': 'Zimbabwe Dollars'}
];

export default currencies;
